import { FirebaseApp, initializeApp } from 'firebase/app'
import dev from './services/firebase/google-services.dev.json'
import prod from './services/firebase/google-services.prod.json'

let _databaseUrl: string

export const databaseUrl = () => _databaseUrl

const configFirebase = (): FirebaseApp => {
  const env = import.meta.env.VITE_ENVIRONMENT
  let config: any

  switch (env) {
    case 'dev':
      config = dev
      break
    case 'prod':
      config = prod
      break
    default:
      config = dev
  }

  _databaseUrl = config['project_info']['firebase_url']

  return initializeApp({
    ...config,
    apiKey: config['client'][0]['api_key'][0]['current_key']
  })
}

let _firebaseApp: FirebaseApp

export const firebaseApp = () => _firebaseApp

const initFirebase = () => {
  if (_firebaseApp == null) {
    _firebaseApp = configFirebase()
  }
  return _firebaseApp
}

export default initFirebase
